module.exports = __webpack_public_path__ + "img/8_1.3e76b420.jpg";